import { Container } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { ReportProvider } from "../../contexts/ReportContext";
import { ResourceProvider } from "../../contexts/ResourceContext";
import withAuthentication from "../../hocs/withAuthentication";
import Form from "./Form";
import History from "./History";

const Page: React.FC = () => {
  return (
    <ResourceProvider>
      <Routes>
        <Route element={<History />} path="/" />
        <Route element={<Form />} path="/create" />
        {/* <Route
          element={
            <ReportProvider>
              <Report type="analysis" />
            </ReportProvider>
          }
          path="/:cycleId/analysis"
        /> */}
        {/* <Route
          element={
            <ReportProvider>
              <Report type="report" />
            </ReportProvider>
          }
          path="/:cycleId/report"
        /> */}
        {/* <Route
          element={
            <ReportProvider>
              <Report type="history" />
            </ReportProvider>
          }
          path="/:cycleId"
        /> */}
      </Routes>
    </ResourceProvider>
  );
};

export default withAuthentication(Page);
